import React from "react";

const NoTitle = () => (
  <svg width="224" height="169" viewBox="0 0 224 169" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M188.315 0H43.4577C36.7908 0 31.3862 5.40456 31.3862 12.0714V156.929C31.3862 163.595 36.7908 169 43.4577 169H188.315C194.982 169 200.386 163.595 200.386 156.929V12.0714C200.386 5.40456 194.982 0 188.315 0Z"
      fill="#B8AEE9"
      fillOpacity="0.13"
    />
    <path
      d="M6.03571 13.5997H169C172.155 13.5997 174.713 16.1577 174.713 19.3131V49.4916C174.713 52.647 172.155 55.205 169 55.205H6.03571C2.88032 55.205 0.322362 52.647 0.322362 49.4916V19.3131C0.322362 16.1577 2.88032 13.5997 6.03571 13.5997Z"
      fill="white"
      stroke="#EBEBEB"
      strokeWidth="0.644724"
    />
    <path
      d="M83.0071 24H51.6214C49.6214 24 48 25.6214 48 27.6214C48 29.6215 49.6214 31.2429 51.6214 31.2429H83.0071C85.0072 31.2429 86.6286 29.6215 86.6286 27.6214C86.6286 25.6214 85.0072 24 83.0071 24Z"
      fill="#9185CB"
      fillOpacity="0.38"
    />
    <path
      d="M104.736 37.6934H51.6214C49.6214 37.6934 48 39.3147 48 41.3148C48 43.3148 49.6214 44.9362 51.6214 44.9362H104.736C106.736 44.9362 108.357 43.3148 108.357 41.3148C108.357 39.3147 106.736 37.6934 104.736 37.6934Z"
      fill="#9185CB"
      fillOpacity="0.12"
    />
    <rect x="9" y="21" width="27" height="27" rx="2.34783" fill="#2D2D2D" />
    <path
      d="M17.8955 38.0221C17.8955 35.9358 17.8955 30.9805 17.8955 30.9805C17.8955 30.083 18.623 29.3555 19.5205 29.3555H25.4788V36.3971C25.4788 36.3971 20.9377 36.3971 19.5205 36.3971C18.6268 36.3971 17.8955 37.1241 17.8955 38.0221Z"
      fill="white"
      stroke="white"
      strokeWidth="0.855263"
      strokeLinejoin="round"
    />
    <path
      d="M25.4788 36.3945C25.4788 36.3945 19.833 36.3945 19.5205 36.3945C18.623 36.3945 17.8955 37.1221 17.8955 38.0195C17.8955 38.917 18.623 39.6445 19.5205 39.6445C20.1188 39.6445 23.0077 39.6445 27.1038 39.6445V29.8945"
      stroke="white"
      strokeWidth="0.855263"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.792 38.0195H25.2087"
      stroke="white"
      strokeWidth="0.855263"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.03571 115.322H169C172.155 115.322 174.713 117.88 174.713 121.036V151.214C174.713 154.37 172.155 156.928 169 156.928H6.03571C2.88032 156.928 0.322362 154.37 0.322362 151.214V121.036C0.322362 117.88 2.88032 115.322 6.03571 115.322Z"
      fill="white"
      stroke="#EBEBEB"
      strokeWidth="0.644724"
    />
    <path
      d="M83.0071 125.723H51.6214C49.6214 125.723 48 127.344 48 129.344C48 131.344 49.6214 132.966 51.6214 132.966H83.0071C85.0072 132.966 86.6286 131.344 86.6286 129.344C86.6286 127.344 85.0072 125.723 83.0071 125.723Z"
      fill="#9185CB"
      fillOpacity="0.38"
    />
    <path
      d="M104.736 139.416H51.6214C49.6214 139.416 48 141.037 48 143.037C48 145.038 49.6214 146.659 51.6214 146.659H104.736C106.736 146.659 108.357 145.038 108.357 143.037C108.357 141.037 106.736 139.416 104.736 139.416Z"
      fill="#9185CB"
      fillOpacity="0.12"
    />
    <rect x="9" y="122.723" width="27" height="27" rx="2.34783" fill="#2D2D2D" />
    <path
      d="M21.3332 138.001V139.001C21.3332 140.289 20.2885 141.334 18.9998 141.334C17.7112 141.334 16.6665 140.289 16.6665 139.001V134.334"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.6665 138.001V139.001C24.6665 140.289 25.7112 141.334 26.9998 141.334C28.2885 141.334 29.3332 140.289 29.3332 139.001V134.334"
      stroke="white"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.6665 130.666H20.3332C18.3081 130.666 16.6665 132.308 16.6665 134.333C16.6665 136.358 18.3081 137.999 20.3332 137.999H25.6665C27.6915 137.999 29.3332 136.358 29.3332 134.333C29.3332 132.308 27.6915 130.666 25.6665 130.666Z"
      fill="white"
      stroke="white"
      strokeWidth="1.33333"
    />
    <path
      d="M22.0002 134.334H19.3335"
      stroke="#2D2D2D"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.6665 133V135.667"
      stroke="#2D2D2D"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.9998 133.667C26.9998 133.298 26.7014 133 26.3332 133C25.965 133 25.6665 133.298 25.6665 133.667C25.6665 134.035 25.965 134.333 26.3332 134.333C26.7014 134.333 26.9998 134.035 26.9998 133.667Z"
      fill="#2D2D2D"
    />
    <path
      d="M25.6668 135.333C25.6668 134.964 25.3684 134.666 25.0002 134.666C24.632 134.666 24.3335 134.964 24.3335 135.333C24.3335 135.701 24.632 135.999 25.0002 135.999C25.3684 135.999 25.6668 135.701 25.6668 135.333Z"
      fill="#2D2D2D"
    />
    <path
      d="M54.0357 64.3224H217C220.155 64.3224 222.713 66.8803 222.713 70.0357V100.214C222.713 103.37 220.155 105.928 217 105.928H54.0357C50.8803 105.928 48.3224 103.37 48.3224 100.214V70.0357C48.3224 66.8803 50.8803 64.3224 54.0357 64.3224Z"
      fill="white"
      stroke="#EBEBEB"
      strokeWidth="0.644724"
    />
    <path
      d="M131.007 74.7227H99.6214C97.6214 74.7227 96 76.344 96 78.3441C96 80.3441 97.6214 81.9655 99.6214 81.9655H131.007C133.007 81.9655 134.629 80.3441 134.629 78.3441C134.629 76.344 133.007 74.7227 131.007 74.7227Z"
      fill="#9185CB"
      fillOpacity="0.38"
    />
    <path
      d="M152.736 88.416H99.6214C97.6214 88.416 96 90.0374 96 92.0374C96 94.0375 97.6214 95.6589 99.6214 95.6589H152.736C154.736 95.6589 156.357 94.0375 156.357 92.0374C156.357 90.0374 154.736 88.416 152.736 88.416Z"
      fill="#9185CB"
      fillOpacity="0.12"
    />
    <rect x="57" y="71.7227" width="27" height="27" rx="2.34783" fill="#2D2D2D" />
    <g clipPath="url(#clip0_3254_20288)">
      <path d="M77 78H63V92H77V78Z" fill="white" fillOpacity="0.01" />
      <path
        d="M71.75 88.0618C71.75 87.4981 72.207 87.041 72.7708 87.041H74.9583V88.0327C74.9583 88.6126 74.4882 89.0827 73.9083 89.0827H72.7708C72.207 89.0827 71.75 88.6256 71.75 88.0618Z"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinejoin="round"
      />
      <path
        d="M64.75 89.2298C64.75 88.666 65.207 88.209 65.7708 88.209H67.6667V89.2007C67.6667 89.7805 67.1966 90.2507 66.6167 90.2507H65.7708C65.207 90.2507 64.75 89.7936 64.75 89.2298Z"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinejoin="round"
      />
      <path
        d="M67.6665 83.2635L74.9582 81.5371"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M67.6665 89.0827V80.916L74.9582 79.166V87.8263"
        stroke="white"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3254_20288">
        <rect width="14" height="14" fill="white" transform="translate(63 78)" />
      </clipPath>
    </defs>
  </svg>
);

export default React.memo(NoTitle);
